var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.order.book_more_hours.length > 0
        ? _c(
            "div",
            [
              _c("hr"),
              _vm._v(" "),
              _vm._l(_vm.order.book_more_hours, function(
                orderAdditionalHours,
                index
              ) {
                return _c("div", [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", { staticClass: "flex-fill" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("message.my_reservations.additional_hours")
                          ) +
                          " #" +
                          _vm._s(orderAdditionalHours.id) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-fill text-right" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(orderAdditionalHours.work_hour) +
                          " " +
                          _vm._s(
                            _vm.$tc(
                              "message.hour",
                              orderAdditionalHours.work_hour
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex mt-1" }, [
                    _c("div", { staticClass: "flex-fill" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("message.my_reservations.sent_request_at")
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex-fill text-right text-secondary" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("prettyDate")(
                                orderAdditionalHours.created_at
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex mt-1" }, [
                    _c("div", { staticClass: "flex-fill" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.my_reservations.status")) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-fill text-right" }, [
                      _c(
                        "span",
                        {
                          class: _vm.getOrderAdditionalHoursStatus(
                            orderAdditionalHours
                          ).textColor
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getOrderAdditionalHoursStatus(
                                  orderAdditionalHours
                                ).status
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  orderAdditionalHours.is_declined &&
                  (orderAdditionalHours.payment_method === "bank_transfer" ||
                    orderAdditionalHours.payment_method === "promptpay")
                    ? _c("div", { staticClass: "pt-2" }, [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-secondary" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "message.my_reservations.request_declined_remark"
                                )
                              ) +
                              "\n        "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !orderAdditionalHours.paid_status &&
                  !orderAdditionalHours.cancel &&
                  orderAdditionalHours.payment_method === "promptpay"
                    ? _c(
                        "div",
                        { staticClass: "pt-3" },
                        [
                          _c("div", { staticClass: "pb-3 text-remark" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "message.my_reservations.qr_payment_unpaid_remark"
                                  )
                                ) +
                                "\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-outline-info btn-block",
                              attrs: {
                                to:
                                  "/reservation/" +
                                  _vm.order.id +
                                  "/additional-hours?id=" +
                                  orderAdditionalHours.id
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.button.qr_payment")) +
                                  "\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  orderAdditionalHours.has_payment_failure &&
                  !orderAdditionalHours.cancel
                    ? _c(
                        "div",
                        { staticClass: "pt-3 -status-alert text-small" },
                        [
                          _c("i", {
                            staticClass: "fas fa-exclamation-triangle"
                          }),
                          _vm._v(
                            "  " +
                              _vm._s(
                                _vm.$t(
                                  "message.my_reservations.payment_failed_remark",
                                  {
                                    remark:
                                      orderAdditionalHours.payment_failure_remark
                                  }
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  orderAdditionalHours.sender_type === "professional" &&
                  !orderAdditionalHours.status &&
                  !orderAdditionalHours.payment_method
                    ? _c("div", { staticClass: "row no-gutters pt-3" }, [
                        _c("div", { staticClass: "col-6 pr-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-info btn-block",
                              on: {
                                click: function($event) {
                                  return _vm.cancelOrderAdditionalHours(
                                    orderAdditionalHours.id
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("message.button.cancel")) +
                                  "\n          "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 pl-1" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-info btn-block",
                                attrs: {
                                  to:
                                    "/reservation/" +
                                    _vm.order.id +
                                    "/additional-hours?id=" +
                                    orderAdditionalHours.id
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("message.button.make_a_payment")
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  orderAdditionalHours.sender_type === "user" &&
                  orderAdditionalHours.status === 0 &&
                  orderAdditionalHours.payment_method === "credit_card"
                    ? _c("div", { staticClass: "pt-3" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-info btn-block",
                            on: {
                              click: function($event) {
                                return _vm.cancelOrderAdditionalHours(
                                  orderAdditionalHours.id
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("message.button.cancel")) +
                                "\n        "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  index + 1 < _vm.order.book_more_hours.length ||
                  _vm.$route.matched[0].path === "/chat-booking"
                    ? _c("hr")
                    : _vm._e()
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("book-additional-hours-modal", {
        ref: "bookAdditionalHoursModal",
        attrs: { parentServiceId: _vm.parentServiceId }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "bullet-notification" }, [
      _c("i", { staticClass: "fas fa-circle" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82d3f85c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82d3f85c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/OrderAdditionalHours.vue
// module id = 1775
// module chunks = 0